export const buyingsStockConstants = {
  GET_BUYINGS: 'GET_BUYINGS',
  GET_BUYINGS_DETAILS: 'GET_BUYINGS_DETAILS',
  CLEAR_BUYINGS_DETAILS: 'CLEAR_BUYINGS_DETAILS',
};
